import React, { useMemo } from "react";
import { Card, CardContent, Typography, Box } from "@material-ui/core";
import { codigosSubcompetencia, valorNormalizado } from "../../utils/subcompetencias";
import { formatNota } from "../../utils/formato";

const TablaResumen = ({ filas = [], totales, totalEstudiantes = 0, loading = false }) => {
  const getColor = (valor) => {
    const v = Number(valor) || 0;
    if (v >= 4) return "#dcfce7";
    if (v >= 3) return "#fef9c3";
    return "#fee2e2";
  };

  const t = totales || { verde: 0, amarillo: 0, rojo: 0 };
  const total = totalEstudiantes || t.verde + t.amarillo + t.rojo;
  const mostrados = Array.isArray(filas) ? filas.length : 0;

  // El número de subcompetencias varía por competencia (RC/LC: C1-C3, CC: C1-C7):
  // se descubren en vez de asumir C1-C3.
  const codigos = useMemo(() => codigosSubcompetencia(filas), [filas]);
  const columnasGrid = `2fr 1fr ${codigos.map(() => "1fr").join(" ")}`.trim();

  if (loading) {
    return (
      <Card style={{ width: "100%", height: "100%", minHeight: 500, display: "flex", flexDirection: "column" }}>
        <CardContent style={{ padding: 16, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1 }}>
          <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
            Tabla de Rendimiento
          </Typography>
          <Typography variant="body2" color="textSecondary" align="center">
            Cargando resultados…
          </Typography>
        </CardContent>
      </Card>
    );
  }

  if (!mostrados) {
    return (
      <Card style={{ width: "100%", minHeight: 500 }}>
        <CardContent>
          <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0f172a" }}>
            Tabla de Rendimiento
          </Typography>
          <Typography variant="body2" color="textSecondary">
            No hay datos para los filtros seleccionados.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card style={{ width: "100%", height: "100%", minHeight: 500, display: "flex", flexDirection: "column" }}>
      <CardContent
        style={{
          padding: 6,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0f172a" }}>
          Tabla de Rendimiento
        </Typography>

        <Box style={{ overflowX: "auto", flex: 1, display: "flex", flexDirection: "column" }}>
          <Box style={{ minWidth: codigos.length > 3 ? codigos.length * 60 + 160 : "auto" }}>
            <Box
              style={{
                display: "grid",
                gridTemplateColumns: columnasGrid,
                fontWeight: 700,
                padding: "6px 8px",
                fontSize: 12,
                borderBottom: "2px solid #e5e7eb",
                background: "#f8fafc",
              }}
            >
              <span>Correo</span>
              <span>Total</span>
              {codigos.map((c) => (
                <span key={c}>{c}</span>
              ))}
            </Box>

            <Box style={{ overflowY: "auto" }}>
              {filas.map((item) => (
                <Box
                  key={`${item.id}-${item.Correo}`}
                  style={{
                    display: "grid",
                    gridTemplateColumns: columnasGrid,
                    padding: "4px 8px",
                    fontSize: 11,
                    background: getColor(item.Total),
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <span>{item.Correo}</span>
                  <span>{formatNota(item.Total)}</span>
                  {codigos.map((c) => (
                    <span key={c}>{formatNota(valorNormalizado(item, c))}</span>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box mt={0.5} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" style={{ gap: 8 }}>
          <Typography variant="caption">
            Mostrando {mostrados} de {total} estudiantes (máx. 8 por nivel)
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Verde: {t.verde} · Amarillo: {t.amarillo} · Rojo: {t.rojo}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TablaResumen;
